export const MINIMUM_OFFER_DISCOUNT_TO_SHOW = 5
